import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import i18nextHttpBackend from 'i18next-http-backend'

// available languages
const languages = ['en', 'he']

// available namespaces, add more as needed
const namespaces = ['translation', 'labels']

// init i18n
i18n
  .use(i18nextHttpBackend)
  .use(initReactI18next)
  .init({
    // debug: import.meta.env.DEV,
    // saveMissing: true,
    lng: 'en',
    fallbackLng: false,
    supportedLngs: languages,
    ns: namespaces,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {},
  })

// load translation files after init
;(async () => {
  await Promise.all(
    languages.map(async (lng) => {
      return namespaces.map(async (ns) => {
        import(`./${lng}/${ns}.json`).then((res) => {
          return i18n.addResourceBundle(lng, ns, res.default)
        })
      })
    })
  )
})()

export default i18n
